export function info(m: string, ...args: unknown[]): void {
    if (process.env.NODE_ENV !== 'production') {
        /* tslint:disable:no-console */
        console.info(m, ...args);
        /* tslint:enable:no-console */
    }
}

export function warning(m: string): void {
    if (process.env.NODE_ENV !== 'production') {
        console.warn(m);
    }
}
